exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fmcy-vendor-selected {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n  .fmcy-vendor-selected .fmcy-selected-vendor-name {\n    color: #00afb4; }\n  .fmcy-vendor-selected .fmcy-search-clear-filters-x-btn {\n    color: #00afb4; }\n\n@media only screen and (max-width: 780px) {\n  .fmcy-vendor-selected {\n    max-width: 110px; } }\n\n@media only screen and (max-width: 410px) {\n  .fmcy-vendor-selected {\n    max-width: 70px; } }\n\n@media only screen and (max-width: 360px) {\n  .fmcy-vendor-selected {\n    max-width: 38px; } }\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./assets/js/common/menu/subfilters/vendor-select-selected/vendor-select-selected.scss
 ** module id = 549
 ** module chunks = 1 7 43 115
 **/